angular.module('dpw.directives').directive('dpwPopupYoutubeVideo', [function () {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'dpw-popup-youtube-video.html',
        controllerAs: 'ctrl',
        controller: ['$scope', function ($scope) {
            this.videoUrl = $scope.config.videoUrl;
            this.width = $scope.config.width;

            this.close = function () {
                $scope.config.close();
            }
        }]
    };
}]);